import React, { createContext, useContext } from 'react';
import T from 'prop-types';

const BeanieCtx = createContext(null);

const BeanieProvider = ({ apiKey, configId, children }) => {
  const { OctobatBeanie } = window;
  let beanie;

  if (OctobatBeanie) {
    beanie = OctobatBeanie(apiKey);
  }

  return <BeanieCtx.Provider value={{ beanie, configId }}>{children}</BeanieCtx.Provider>;
};

BeanieProvider.propTypes = {
  apiKey: T.string.isRequired,
  configId: T.string.isRequired,
  children: T.node.isRequired,
};

export default BeanieProvider;

export const useBeanieCtx = () => useContext(BeanieCtx);
